import { useCallback } from 'react'

import {
  synthesis,
  getDishMasterContract,
  getPokerBlindBoxContract,
  getBakerySoccerMasterContract,
  pokerBlindBoxContractMint,
  getSoccerPokerGameBoxContract,
  soccerPokerGameBoxMint,
  getCarBlindBoxContract,
  carBlindBoxContractMint,
  getDoggyNFTContract,
  doggyNFTContractMint,
  getBarkingNFTContract,
  barkingNFTContractMint,
  getDoggyEquipmentContract,
  doggyEquipmentMint,
  getDoggyAddress,
  getMatrixPlusBoxContract,
  matrixPlusBoxContractMint,
  getRacaAddress,
  getGaAddress
} from '../../sushi/utils'

import {
  getBakeMuskMixerContract,
  mintByBNB,
  lucky
} from '../../sushi/bakeMuskMixer'

import {
  getMuskUsmLandContract,
  mintByBNB as muskUsmLandMintByBNB
} from '../../sushi/muskUsmLand'

import { NFTTYPE } from '../../constants/bakery/nft'
import BigNumber from 'bignumber.js'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import { getSellNFTsContract, buyByBNB } from '../../sushi/sellNFTs'

const useSynthesis = (type?: string) => {
  const {account} = useActiveWeb3React()
  const sushi = useYam()
  let mastercontract = getDishMasterContract(sushi)

  switch (type) {
    case NFTTYPE.SOCCER:
      mastercontract = getBakerySoccerMasterContract(sushi)
      break
    case NFTTYPE.POKER:
      mastercontract = getPokerBlindBoxContract(sushi)
      break
    case NFTTYPE.GAMEBOX:
      mastercontract = getSoccerPokerGameBoxContract(sushi)
      break
    case NFTTYPE.CAR:
      mastercontract = getCarBlindBoxContract(sushi)
      break
    case NFTTYPE.DOGGIES:
      mastercontract = getDoggyNFTContract(sushi)
      break
    case NFTTYPE.BARKING:
      mastercontract = getBarkingNFTContract(sushi)
      break
    case NFTTYPE.EQUIPMENT:
      mastercontract = getDoggyEquipmentContract(sushi)
      break
    case NFTTYPE.MATRIX:
      mastercontract = getMatrixPlusBoxContract(sushi)
      break
    case NFTTYPE.BAKEMUSKMIXER:
      mastercontract = getBakeMuskMixerContract(sushi)
      break
    case NFTTYPE.MUSKUSMLAND:
      mastercontract = getMuskUsmLandContract(sushi)
      break
    case NFTTYPE.GAMEACE:
      mastercontract = getSellNFTsContract(sushi)
      break
  }

  const handleSynthesis = useCallback(
    async (amount: string, payToken?: string, tokenIsBNB?: boolean) => {
      let txHash
      switch (type) {
        case NFTTYPE.SOCCER:
          txHash = await synthesis(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.POKER:
          txHash = await pokerBlindBoxContractMint(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.GAMEBOX:
          txHash = await soccerPokerGameBoxMint(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.CAR:
          txHash = await carBlindBoxContractMint(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.DOGGIES:
          txHash = await doggyNFTContractMint(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.BARKING:
          txHash = await barkingNFTContractMint(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.EQUIPMENT:
          const doggyAddress = getDoggyAddress(sushi)
          const payAmount = new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()
          txHash = await doggyEquipmentMint(
            mastercontract,
            doggyAddress,
            payAmount,
            account
          )
          break
        case NFTTYPE.MATRIX:
          let decimals = 18
          if(getRacaAddress(sushi) === payToken){
            decimals = 9
          }
          amount = new BigNumber(amount).times(new BigNumber(10).pow(decimals)).toString()
          txHash = await matrixPlusBoxContractMint(
            mastercontract,
            payToken,
            amount,
            account,
          )
          break
        case NFTTYPE.BAKEMUSKMIXER:
          amount = new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()
          if(tokenIsBNB){
            txHash = await mintByBNB(
              mastercontract,
              amount,
              account,
            )
          }else{
            txHash = await lucky(
              mastercontract,
              payToken,
              amount,
              account,
            )
          }
          break
        case NFTTYPE.MUSKUSMLAND:
          amount = new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()
          txHash = await muskUsmLandMintByBNB(
            mastercontract,
            amount,
            account,
          )
          break
        case NFTTYPE.GAMEACE:
          const nftToken = getGaAddress(sushi)
          amount = new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()
          txHash = await buyByBNB(
            mastercontract,
            nftToken,
            amount,
            account,
          )
          break
      }
      return txHash
    },
    [account, mastercontract, type, sushi]
  )

  return { onSynthesis: handleSynthesis }
}

export default useSynthesis
